export enum State {
  Idle = 'idle',
  Paused = 'paused',
  Running = 'running',
  Stopped = 'stopped',
}
